<template>
  <div>
    <b-table
      responsive
      striped
      hover
      :fields="fields"
      :items="items"
      :busy="isBusy"
      show-empty
      empty-text="ไม่พบข้อมูล"
    >
      <template #cell(id)="{ item }">
        <p class="underline" @click="editCategory(item)">{{ item.id }}</p>
      </template>
      <template #cell(showImgUrl)="{ item }">
        <div class="container">
          <img class="render-image" :src="item.showImgUrl" />
        </div>
      </template>

      <template #cell(isActive)="{ item }">
        <p
          class="m-0"
          :class="item.isActive == true ? 'color-green' : 'color-red'"
        >
          {{ item.isActive == true ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
        </p>
      </template>

      <template v-slot:cell(actions)="{ item }">
        <div class="container">
          <font-awesome-icon
            class="mr-4 pointer"
            icon="pen"
            @click="editCategory(item)"
          ></font-awesome-icon>

          <b-form-checkbox
            @change="onChangeStatus(item)"
            v-model="item.isActive"
            class="pointer"
            switch
            :value="true"
            :unchecked-value="false"
          />
        </div>
      </template>

      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
    </b-table>

    <Pagination
      @handleChangeTake="handleChangeTake"
      :pageOptions="pageOptions"
      :rows="rows"
      :filter="filter"
      @pagination="pagination"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "CategoryTable",
  components: { Pagination },
  props: {
    filter: {
      required: false,
      type: Object,
    },
    pageOptions: {
      required: true,
      type: Array,
    },
    fields: {
      required: true,
      type: Array,
    },
    items: {
      required: true,
      type: Array,
    },
    isBusy: {
      required: true,
      type: Boolean,
    },
    rows: {
      required: true,
      type: Number,
    },
  },
  methods: {
    editCategory(item) {
      this.$emit("editCategory", item);
    },
    inActiveCategory(item) {
      this.$emit("inActiveCategory", item);
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.$emit("filterPage", this.filter);
    },
    pagination(page) {
      this.filter.page = page;
      this.$emit("filterPage", this.filter);
    },
    onChangeStatus(val) {
      this.$emit("onChangeStatus", val);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep thead {
  background-color: var(--secondary-color);
  color: var(--font-color);
}

.color-red {
  color: #dc3545;
}

.color-green {
  color: #28a745;
}

.color-blue {
  color: lightcoral;
}

.text-time {
  opacity: 0.5;
}

.underline {
  text-decoration: underline;
  cursor: pointer;
}

.render-image {
  margin: auto;
  display: block;
  max-width: 200px;
  max-height: 95px;
  width: auto;
  height: auto;
  text-align: center;
}
.container {
  min-height: 100px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.underline {
  text-decoration: underline;
  cursor: pointer;
}
</style>
